import { render, staticRenderFns } from "./MemberAmount.vue?vue&type=template&id=5672a187"
import script from "./MemberAmount.vue?vue&type=script&lang=ts"
export * from "./MemberAmount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports